import React from 'react';
import { handleTrack } from '../../../../utils/tracker';

interface ContactUsSectionProps {
  setContactUsModal: (open: boolean) => void;
  pocName?: string;
  pocPhone?: string;
  pocEmail?: string;
  className?: string;
}

export const ContactUsSection: React.FC<ContactUsSectionProps> = ({
  setContactUsModal,
  className,
  pocName,
  pocPhone,
  pocEmail,
}) => {
  return (
    <div
      className={`text-base justify-between text-font-500 font-medium mt-10 gap-2  ${className}`}
    >
      <div className="text-base ">
        For any support, reach out to <strong>{pocName}</strong>@ {pocPhone} or{' '}
        <span className="text-blue-300">{pocEmail}</span>
      </div>

      <p
        className="flex gap-1 mt-1 font-bold text-base text-blue-600 sm:text-s-14 hover:cursor-pointer"
        onClick={(e) => {
          setContactUsModal(true);
          handleTrack({
            label: 'hero_cta_',
            obj: e.target,
          });
        }}
      >
        Request Callback &gt;
      </p>
    </div>
  );
};
